import { Navigate, Route, Routes as RouterRoutes } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import TemplateDefault from '../components/TemplateDefault'
import LoginForm from '../components/LoginForm'
import ForgotPassword from '../components/ForgotPassword'
import { PageAuthorization } from '../components/PageAuthorization'

import Dashboard from '../components/View/Dashboard'
import ProductionOrder from '../components/View/ProductionOrder'
import ProductionOrderDetail from '../components/View/ProductionOrder/Detail'
import ProductionOrderCreate from '../components/View/ProductionOrder/Create'
import ProductionKanban from '../components/View/ProductionKanban'
import Product from '../components/View/Product'
import ChargeProduct from '../components/View/ChargeProduct'
import ProductAssociation from '../components/View/ProductAssociation'
import ConversionFactor from '../components/View/ConversionFactor'
import MachineRecipe from '../components/View/MachineRecipe'
import PrinterZpl from '../components/View/PrinterZpl'
import ChargeRecipeMachine from '../components/View/ChargeRecipeMachine'
import RfidTracking from '../components/View/RfidTracking'
import RfidQuery from '../components/View/RfidQuery'
import RfidTimeline from '../components/View/RfidTimeline'
import ProcessFlow from '../components/View/ProcessFlow'
import Users from '../components/View/Users'
import Permissions from '../components/View/Permissions'
import Audit from '../components/View/Audit'
import Sync from '../components/View/Sync'
import Reports from '../components/View/Reports'
import Migration from '../components/View/Migration'
import { PERMISSOES } from '../const/permissoes'

/** Envolve a página no layout padrão + guarda de permissão. */
const page = (element, permissao) => (
  <PrivateRoute permissao={permissao}>
    <TemplateDefault>{element}</TemplateDefault>
  </PrivateRoute>
)

const Routes = () => (
  <RouterRoutes>
    <Route path="/" element={<Navigate to="/dashboard" replace />} />
    <Route path="/Login" element={<LoginForm />} />
    <Route path="/ForgotPassword" element={<ForgotPassword />} />
    <Route path="/Aviso" element={page(<PageAuthorization />)} />

    {/* Épico 01 */}
    <Route path="/dashboard" element={page(<Dashboard />, PERMISSOES.DASHBOARD_VISUALIZAR)} />

    {/* Épico 02 */}
    <Route path="/MovBreak" element={page(<ProductionOrder />, PERMISSOES.ORDEM_VISUALIZAR)} />
    {/* Antes de `/MovBreak/:id`: "MovBreakCreate" não é um id de ordem. */}
    <Route
      path="/MovBreakCreate"
      element={page(<ProductionOrderCreate />, PERMISSOES.ORDEM_CRIAR)}
    />
    <Route
      path="/MovBreak/:id"
      element={page(<ProductionOrderDetail />, PERMISSOES.ORDEM_VISUALIZAR)}
    />

    {/* Épico 06 */}
    <Route
      path="/MovBreakKanban"
      element={page(<ProductionKanban />, PERMISSOES.KANBAN_VISUALIZAR)}
    />

    {/* Épico 03 */}
    <Route path="/products" element={page(<Product />, PERMISSOES.PRODUTO_VISUALIZAR)} />
    <Route
      path="/chargeProduct"
      element={page(<ChargeProduct />, PERMISSOES.PRODUTO_GERENCIAR)}
    />
    <Route
      path="/ProductAssociation"
      element={page(<ProductAssociation />, PERMISSOES.RFID_VISUALIZAR)}
    />
    {/* Mesma rota do sistema antigo, para link salvo continuar valendo. */}
    <Route path="/QuantityBox" element={page(<ConversionFactor />, PERMISSOES.PRODUTO_VISUALIZAR)} />

    {/* Receitas de máquina */}
    <Route path="/machineRecipe" element={page(<MachineRecipe />, PERMISSOES.RECEITA_VISUALIZAR)} />
    <Route path="/PrinterZpl" element={page(<PrinterZpl />, PERMISSOES.RFID_VISUALIZAR)} />
    <Route
      path="/chargeRecipeMachine"
      element={page(<ChargeRecipeMachine />, PERMISSOES.RECEITA_GERENCIAR)}
    />

    {/* Épicos 04, 05 e 08 */}
    <Route path="/RfidTracking" element={page(<RfidTracking />, PERMISSOES.RFID_VISUALIZAR)} />
    <Route path="/RfidQuery" element={page(<RfidQuery />, PERMISSOES.RFID_VISUALIZAR)} />
    <Route path="/RfidTimeline" element={page(<RfidTimeline />, PERMISSOES.RFID_VISUALIZAR)} />
    <Route path="/RfidTimeline/:epc" element={page(<RfidTimeline />, PERMISSOES.RFID_VISUALIZAR)} />

    {/* Épico 07 */}
    <Route path="/ProcessFlow" element={page(<ProcessFlow />, PERMISSOES.FLUXO_VISUALIZAR)} />

    {/* Épicos 09 a 12 */}
    <Route path="/Reports" element={page(<Reports />, PERMISSOES.RELATORIO_VISUALIZAR)} />
    <Route path="/Users" element={page(<Users />, PERMISSOES.USUARIO_VISUALIZAR)} />
    <Route path="/Permissions" element={page(<Permissions />, PERMISSOES.USUARIO_VISUALIZAR)} />
    <Route path="/Audit" element={page(<Audit />, PERMISSOES.AUDITORIA_VISUALIZAR)} />

    {/* Migração do banco de origem — mesma capacidade da sincronização. */}
    <Route
      path="/Migration"
      element={page(<Migration />, PERMISSOES.SINCRONIZACAO_VISUALIZAR)}
    />

    {/* Épicos 19 e 26 — carga incremental e consistência. */}
    <Route path="/Sync" element={page(<Sync />, PERMISSOES.SINCRONIZACAO_VISUALIZAR)} />

    <Route path="*" element={<Navigate to="/dashboard" replace />} />
  </RouterRoutes>
)

export default Routes
